import Backbone from 'backbone'
import TitleModel from '../models/title'

const TitleList = Backbone.Collection.extend({
    model: TitleModel,
    previous(currentModel) {
        const currentIndex = this.indexOf(currentModel)
        if (currentIndex > 0) {
            let title = this.at(currentIndex - 1)

            if (title.get('purchased') || title.get('free')) {
                return title
            }

            return null
        }
        return null
    },
    next(currentModel) {
        const currentIndex = this.indexOf(currentModel)
        if (currentIndex < this.length - 1) {
            let title = this.at(currentIndex + 1)

            if (title.get('purchased') || title.get('free')) {
                return title
            }

            return null
        }
        return null
    }
})

export default TitleList
